import { useAutoFocusContext } from '../contexts';

// Create a safe hook that handles context availability
export const useAutoFocusContextSafe = () => {
	// Simply use the context hook - it now returns null if not available
	return useAutoFocusContext();
};